import Cookies from 'js-cookie';
import Toastify from 'toastify-js';

export default class DarkModeToggle {

	constructor(element) {
		this.handleChange = this.handleChange.bind(this);
		this.element = element;
		this.checkbox = (this.element instanceof HTMLElement) ? this.element.querySelector('.gigs-dark-mode-toggle__checkbox') : undefined;
		this.body = document.querySelector('.gigs');
		this.darkClass = 'gigs--dark';
		this.themeMeta = document.querySelector('meta[name="theme-color"]');
		this.darkThemeColor = '#141413';
		this.lightThemeColor = '#ffffff';
	}

	init() {
		if (this.checkbox instanceof HTMLElement) {
			this.checkbox.addEventListener('change', this.handleChange);
		}
	}

	destroy() {
		if (this.checkbox instanceof HTMLElement) {
			this.checkbox.removeEventListener('change', this.handleChange);
		}
	}

	setInitialMode() {
		const cookieDark = (Cookies.get('gigs_is_dark_mode') === '1');
		const cookieLight = (Cookies.get('gigs_is_dark_mode') === '0');
		const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches || false;
		if (cookieDark || (prefersDark && ! cookieLight)) {
			this.setDark();
		} else {
			this.setLight();
		}
	}

	showToast(text = '') {
		Toastify({
			text: text,
			duration: 3000,
			className: 'gigs-toast',
			close: true,
			gravity: 'bottom',
			position: 'right',
			stopOnFocus: true,
			offset: {
				x: 20,
				y: 20,
			},
		}).showToast();
	}

	setDark() {
		document.documentElement.style.colorScheme = 'dark';
		if (this.body instanceof HTMLElement) {
			this.body.classList.add(this.darkClass);
		}
		if (this.checkbox instanceof HTMLInputElement) {
			if (! this.checkbox.checked) {
				this.checkbox.checked = true;
			}
		}
		if (this.themeMeta instanceof HTMLElement) {
			this.themeMeta.setAttribute('content', this.darkThemeColor);
		}
	}

	setLight() {
		document.documentElement.style.colorScheme = 'light';
		if (this.body instanceof HTMLElement) {
			this.body.classList.remove(this.darkClass);
		}
		if (this.checkbox instanceof HTMLInputElement) {
			if (this.checkbox.checked) {
				this.checkbox.checked = false;
			}
		}
		if (this.themeMeta instanceof HTMLElement) {
			this.themeMeta.setAttribute('content', this.lightThemeColor);
		}
	}

	handleChange(e) {
		const { checked } = e.target;
		if (checked) {
			Cookies.set('gigs_is_dark_mode', '1');
			this.showToast(window.gigs.darkModeToast);
			this.setDark();
		} else {
			Cookies.set('gigs_is_dark_mode', '0');
			this.showToast(window.gigs.lightModeToast);
			this.setLight();
		}
	}
}
